export default __webpack_public_path__ + "static/media/linkedin_light.c6ec05f8.svg";